import React, { useState, useEffect,useContext } from "react";
import { getPatinetMedicalHistoryData, updatePatinetMedicalHistory, createPatinetMedicalHistory } from "../../../actions/configuration";
import { dateFormat } from "../../../lib/functions";
import { Button } from "@material-ui/core";
import Loader from "../../../lib/ui/loader/Loader";
import { RoleCtx, LangCtx, PayLoadCtx } from "../../../lib/context";
import ReactQuillEditor from "../../../components/reactQuillEditor";
import ReactQuill from "react-quill";
import { toast } from "react-toastify";
import "react-quill/dist/quill.snow.css";

const PatientHistoryDetails = ({ data }) => {
    const { role } = useContext(RoleCtx);
    const { payload } = useContext(PayLoadCtx);
    const { l } = useContext(LangCtx);
    const [skip, setSkip] = useState(null);
    const [count, setCount] = useState(0);
    const [history, SetHistory] = useState([]);
    const [loading, setLoading] = useState(false);
    const [editIndex, setEditIndex] = useState(null);
    const [editedContent, setEditedContent] = useState("");
    const [medHistory, setMedHistory] = useState({
            id: "",
            history: "",
        });

    const handlePatientHistoryData = () => {
        setLoading(true);
        const query = `?did=${data?.doctorId}&pid=${data?.patientId}&limit=10&skip=${skip ? skip : 0}`;
        getPatinetMedicalHistoryData(query)
            .then((res) => {
                if (res?.status && res?.data && skip > 0) {
                    SetHistory([...history, ...res?.data])
                    setCount(Number(res?.count));
                } else {
                    SetHistory(res?.data)
                    setCount(Number(res?.count));
                }
                setLoading(false);
            })
            .catch((e) => {
                console.error("Error fetching patient history:", e);
                setLoading(false);
            });
    };

    const handleEdit = (index, content) => {
        setEditIndex(index);
        setEditedContent(content);
    };

    const handleCancel = () => {
        setEditIndex(null);
        setEditedContent("");
    };

    const handleSubmitData = async () => {
        setLoading(true);
            let createbody = {
                doctorId: data?.doctorId,
                appointmentId: data?.appointmentId,
                clinicId: data?.clinicId,
                patientId: data?.patientId,
                subdomain: payload?.subdomain,
            };
            if (medHistory?.history && medHistory?.history !== "") {
                createbody["medicalHistory"] = medHistory?.history;
            }
            await createPatinetMedicalHistory(createbody)
                .then((res) => {
                    if (res?.status) {
                        toast.success(res?.data, {
                            position: toast.POSITION.TOP_RIGHT,
                        });
                        setMedHistory({
                            id: "",
                            history: "",
                        });
                        setSkip(0)
                    } else {
                        toast.error(res?.error, {
                            position: toast.POSITION.TOP_RIGHT,
                        });
                    }
                    setLoading(false);
                })
                .catch((e) => {
                    console.log("e.........:", e);
                    setLoading(false);
                });
    };

    const handleSave = (record) => {
        setLoading(true);
        const updatedRecord = {
            dId: data?.doctorId, 
            id: record?._id,
            medicalHistory: editedContent,
        };

        updatePatinetMedicalHistory(updatedRecord)
            .then(() => {
                SetHistory((prevHistory) =>
                    prevHistory.map((history) =>
                        history._id === record._id ? { ...history, medicalHistory: editedContent } : history
                    )
                  );
                setEditIndex(null);
                setEditedContent("");
                setLoading(false);
            })
            .catch((e) => {
                console.error("Error updating medical history:", e);
                setLoading(false);
            });
    };

    useEffect(() => {
        handlePatientHistoryData();
    }, [skip]);

    const handleTerms = (value) => {
        setMedHistory({ ...medHistory, history: value });
    };

    return (
        <>
        {role === "D" && (
            <>
                <div className=" pdngXS">
                    <ReactQuillEditor
                        type="certificate"
                        placeholder="Patinet Medical History"
                        name="medicalHostory"
                        textData={medHistory?.history}
                        setTextData={handleTerms}
                    />
                </div>
                    <div className="pdngHXSM flexRow justfiyEnd">
                    <div className="pdngHXSM">
                        <Button
                        style={{textTransform:'capitalize'}}
                            variant="outlined"
                            color="primary"
                            size="small"
                            onClick={() => {
                                setMedHistory({ ...medHistory, history: "" });
                            }}
                        >
                            Reset
                        </Button>
                        </div>
                  
                    <Button
                    style={{ textTransform: 'capitalize' }}
                    buttonType="submit"
                    variant="contained"
                    color="primary"
                    size="small"
                    className="whiteTxt"
                    onClick={handleSubmitData}
                    disabled={!medHistory.history || medHistory.history.trim() === ""}
                    >
                        Save
                    </Button>
                    </div>
            </>
        )}
        <div className="flexMinHeightCol pdngXS scrollY">
            {loading && <Loader />}
            {history.length > 0 &&
                history.map((each, index) => (
                    <div key={index} className="flexCol pdngXS brdrBtm">
                        <div className="flexRow pdngTB8">
                            <span className="titleHeading headingSM">Date:</span>
                            <span className="titleHeading headingMD">{dateFormat(each?.createdAt)}</span>
                        </div>
                        {editIndex === index ? (
                            <>
                            <div>
                                <ReactQuill
                                    theme="snow"
                                    value={editedContent}
                                    onChange={setEditedContent}
                                    className="HistoryEditor"
                                />
                                </div>
                                <div className="flexRow justfiyEnd" style={{padding:'10px'}}>
                                    <Button
                                        onClick={handleCancel}
                                        size="small"
                                        variant="outlined"
                                        color="secondary"
                                        style={{ marginRight: "8px",textTransform:'capitalize' }}
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                     style={{textTransform:'capitalize',color:'#fff'}}
                                        onClick={() => handleSave(each)}
                                        size="small"
                                        variant="contained"
                                        color="primary"
                                    >
                                        Save
                                    </Button>
                                </div>
                            </>
                        ) : (
                            <>
                                <div
                                    className="lightTxt"
                                    dangerouslySetInnerHTML={{ __html: each?.medicalHistory }}
                                    style={{
                                        wordWrap: "break-word",
                                        overflowWrap: "break-word",
                                        whiteSpace: "normal",
                                    }}
                                />
                                 {role === "D" && (
                                <div className="flexRow justfiyEnd" >
                                    <Button
                                    style={{textTransform:'capitalize'}}
                                        onClick={() => handleEdit(index, each?.medicalHistory)}
                                        variant="outlined"
                                        size="small"
                                        color="primary"
                                    >
                                        Edit
                                    </Button>
                                </div>
                                )}
                            </>
                        )}
                    </div>
                ))}
            {count - history.length > 0 && (
                <div
                    className="flexRow alignCenter justifyCenter mrgTop8"
                    // style={{position:'sticky',bottom:0,zIndex:999,background:'#fff'}}
                    onClick={() => setSkip(skip + 1)}
                >
                    <Button variant="contained" color="primary" className="whiteTxt"  style={{textTransform:'capitalize'}}>
                        Load More
                    </Button>
                </div>
            )}
        </div>
        </>
    );
};

export default PatientHistoryDetails;
